module.exports = __webpack_public_path__ + "assets/img/en-a71d6933.png";